import {_BaseObjectField} from "../../common/basic_fields.js";
import styles from './styles.scss';

class PeriodicSelect extends HTMLElement {
    constructor() {
        super();

        //get attributes
        const kind = this.getAttribute('kind') || "";
        const type = this.getAttribute('type') || "";
        const cssSalt = this.getAttribute('css-salt');

        //fill options
        this.options = {};
        switch (type) {
            case "year": {
                this.options = [
                    {value: 0, text: "в день выдачи кредита"},
                    {value: 1, text: "в последний день года"},
                    {value: 2, text: "дата и месяц", dropdown: true},
                ];
                break;
            }
            case "month": {
                this.options = [
                    {value: 0, text: "в день выдачи кредита"},
                    {value: 1, text: "в последний день месяца"},
                    {value: 2, text: "дата", dropdown: true},
                ];
                break;
            }
            default: {
                this.options = [{
                    value: 0, text: "no type",
                }];
                break;
            }
        }

        //default value
        this._defaultValue = {
            selected: 0, text: this.options[0].text
        };
        switch (type) {
            case "year": {
                this._defaultValue.month = 1;
            }
            case "month": {
                this._defaultValue.day = 1;
                break;
            }
        }

        //create properties
        this._value = tools.deepcopy(this._defaultValue);
        this.$elements = {};

        //Fill the dropdowns
        this.dropdowns = {
            days: [],
            months: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"].map((m, i) => {return {text: m, value: i + 1};}),
        };

        const setDays = (lastDay = 31) => {
            this.dropdowns.days = [];
            for (let i = 1; i <= lastDay; i++) {
                this.dropdowns.days.push({text: i < 10 ? '0' + i : i, value: i});
            }
        };
        setDays();

        const getDropdownFiller = (name, selectedValue) => {
            let filler = '';
            this.dropdowns[name].forEach((o, i) => {
                filler += '<option value="' + o.value + '" ' + (selectedValue == o.value || (selectedValue == null && i == 0) ? 'selected' : '') + '>' + o.text + '</option>';
            });
            return filler;
        };

        const getDropdownText = (name, value) => {
            const el = this.dropdowns[name].find(o => o.value == value);
            return el ? el.text : null;
        }

        const buttonDiv = `<div class="button" tabindex="0"><div class="text">${this._value.text}</div></div>`;

        let windowDiv = `<div class="window-div">`;
        const radioName = `periodic_${Math.random()}`;
        this.options.forEach((o, i) => {
            if (i > 0 && o.dropdown != this.options[i - 1].dropdown) {
                windowDiv += `<div class="line"></div>`;
            }
            windowDiv += `<div class="radio"><label><input type="radio" name="${radioName}" value="${o.value}"${i == 0 ? " checked" : ""}><p>${o.text}</p></label>`;
            if (o.dropdown) {
                windowDiv += `<div class="dropdowns ${type}">`;
                switch (type) {
                    case "year": {
                        windowDiv += `<dropdown-select class="days" kind="sharp-right" ie-fix><select slot="list">${getDropdownFiller('days')}</select></dropdown-select>` +
                            `<dropdown-select class="months" kind="sharp-left" ie-fix><select slot="list">${getDropdownFiller('months')}</select></dropdown-select>`;
                        break;
                    }
                    case "month": {
                        windowDiv += `<dropdown-select class="days" ie-fix><select slot="list">${getDropdownFiller('days')}</select></dropdown-select>`;
                        break;
                    }
                }
                windowDiv += `</div>`;
            }
            windowDiv += `</div>`;
        });
        windowDiv += `</div>`;

        //scss
        const stylesHtml = `<link rel="stylesheet" href="${styles}?v=${cssSalt}" />`;

        this.attachShadow({mode: 'open'});
        this.shadowRoot.innerHTML = stylesHtml + `<div class="periodic ${kind}">${buttonDiv}${windowDiv}</div>`;

        const updateText = () => {
            const option = this.options[this._value.selected];
            if (option.dropdown) {
                switch (type) {
                    case "year": {
                        this._value.text = this._value.day + '-го ' + getDropdownText('months', this._value.month);
                        break;
                    }
                    case "month": {
                        this._value.text = this._value.day + '-го числа';
                        break;
                    }
                }
            } else
                this._value.text = option.text;

            this.$elements.$buttonText.html(this._value.text);
        };

        this.setValues = (newValues) => {
            const values = newValues || this._defaultValue;

            this._value = tools.deepcopy(values);

            switch (type) {
                case "year": {
                    this.$elements.$monthsDropdown.val(values.month);
                }
                case "month": {
                    this.$elements.$daysDropdown.val(values.day);
                    break;
                }
            }
            this.$elements.$windowDiv.find(`input[name="${radioName}"][value="${values.selected}"]`).prop("checked", true);

            updateText();
        };

        const radioChange = () => {
            this._value.selected = +this.$elements.$windowDiv.find(`input[name="${radioName}"]:checked`).val();
            updateText();
        };

        const dropdownChange = () => {
            switch (type) {
                case "year": {
                    const month = this.$elements.$monthsDropdown.val();
                    let day = this.$elements.$daysDropdown.val();
                    if (this._value.month != month) {
                        this._value.month = month;
                        switch (month) {
                            case 2: {
                                setDays(29);
                                if (day > 29)
                                    day = 29;
                                break;
                            }
                            case 4:
                            case 6:
                            case 9:
                            case 11: {
                                setDays(30);
                                if (day > 30)
                                    day = 30;
                                break;
                            }
                            default: {
                                setDays();
                                break;
                            }
                        }
                        this.$elements.$daysDropdown[0].options = this.dropdowns.days;
                        this.$elements.$daysDropdown[0].selectedIndex = day - 1;
                    }
                    this._value.day = day;
                    break;
                }
                case "month": {
                    this._value.day = this.$elements.$daysDropdown.val();
                    break;
                }
            }

            const radioValue = this.options.find(o => o.dropdown).value;
            this.$elements.$windowDiv.find(`input[name="${radioName}"][value="${radioValue}"]`).prop("checked", true);
            radioChange();
        };

        const closeWindow = () => {
            this.$elements.$periodic.removeClass('expanded');
            $(window).off("click", closeWindowOutside);
            this.$elements.$windowDiv.find(`input[name="${radioName}"]`).off('change', radioChange);
            this.$elements.$windowDiv.find(`dropdown-select`).off('change', dropdownChange);

            this.$elements.$periodicSelect.trigger('change', this);
        };

        const closeWindowOutside = (e) => {
            if (!this.$elements.$periodicSelect.is(e.target) && !this.$elements.$periodic.is(e.target) && this.$elements.$periodic.has(e.target).length === 0) {
                closeWindow();
            }
        };

        this.toggleWindow = () => {
            if (!this.$elements.$periodic.hasClass('expanded')) {
                this.$elements.$periodic.addClass('expanded');
                $(window).on("click", closeWindowOutside);
                this.$elements.$windowDiv.find(`input[name="${radioName}"]`).on('change', radioChange);
                this.$elements.$windowDiv.find(`dropdown-select`).on('change', dropdownChange);
            } else
                closeWindow();
        };

        const getElements = () => {
            const $periodicSelect = $(this);
            const $shadowRoot = $($periodicSelect[0].shadowRoot);
            const $periodic = $shadowRoot.find(".periodic");
            const $buttonDiv = $periodic.find('.button');
            const $buttonText = $buttonDiv.find('.text');
            const $windowDiv = $periodic.find('.window-div');
            const $daysDropdown = $windowDiv.find('dropdown-select.days');
            const $monthsDropdown = $windowDiv.find('dropdown-select.months');

            this.$elements = {
                $periodicSelect, $shadowRoot, $periodic, $buttonDiv, $buttonText,
                $windowDiv, $daysDropdown, $monthsDropdown
            };
        }

        getElements();

        //set initial values
        this.setValues(this._defaultValue);
    }

    get value() {
        return this._value;
    }

    set value(v) {
        this.setValues(v);
    }

    get defaultValue() {
        return this._defaultValue;
    }

    connectedCallback() {
        this.$elements.$buttonDiv.on("click", this.toggleWindow);
    }

    disconnectedCallback() {
        this.$elements.$buttonDiv.off("click", this.toggleWindow);
    }
}

class PeriodicDateField extends _BaseObjectField {
    static keyName() {return 'periodic';}
}

window.customElements.define('periodic-select', PeriodicSelect);

export {PeriodicDateField};
